<script>
import bem from '@/utils/bem';

const b = bem('create-wizard-module');

export default {
  props: {
    moduleData: {
      type: Object,
      required: true,
    },
    isEditMode: {
      type: Boolean,
      default: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isPopup: {
      type: Boolean,
      default: false,
    },
    companyColors: {
      type: Object,
      default: () => ({
        color1: '',
        color2: '',
        color3: '',
      }),
    },
  },
  emits: ['update'],
  computed: {
    addToCartButtonColor() {
      if (!this.isEditMode && this.companyColors.color2) {
        return this.companyColors.color2;
      }
      return null;
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
  },
};
</script>

<template>
  <div :class="b({ mobile: isMobile })">
    <!-- Desktop Layout -->
    <template v-if="!isMobile">
      <div :class="b('container')">
        <!-- Left Side - Preview Area -->
        <div :class="b('left-side')">
          <!-- Main Preview -->
          <div :class="b('main-preview')">
            <div :class="b('preview-placeholder')" />
            <!-- Expand Icon -->
            <div :class="b('expand-icon')">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 2H14V6M6 14H2V10M14 2L9 7M2 14L7 9"
                  stroke="#7F7F7F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>

          <!-- Toolbar -->
          <div :class="b('toolbar')">
            <div :class="b('toolbar-item')">
              <div :class="b('toolbar-icon')">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="27"
                  height="35"
                  viewBox="0 0 27 35"
                  fill="none"
                >
                  <path
                    d="M25.75 31.46V3.54C25.75 2.14 24.64 1 23.28 1H3.48C2.1 1
                      1 2.14 1 3.54V31.46C1 32.86 2.1 34 3.48 34H23.28C24.64
                      34 25.75 32.86 25.75 31.46Z"
                    stroke="#5F8AA4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.2 13.66C18.88 13.66 20.24 12.27 20.24 10.54C20.24
                      8.82 18.88 7.43 17.2 7.43C15.53 7.43 14.16 8.82 14.16
                      10.54C14.16 12.27 15.53 13.66 17.2 13.66Z"
                    stroke="#5F8AA4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1 19.55C1.86 19.4 2.73 19.33 3.61 19.33C6.64 19.26
                      9.59 20.19 11.95 21.93C15.76 24.75 17.2 29.64 17.2 34"
                    stroke="#5F8AA4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M25.75 23.52C24.07 23 22.31 22.74 20.54 22.74C18.3
                      22.73 16.09 23.15 14.03 23.95"
                    stroke="#5F8AA4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span :class="b('toolbar-label')">Portrait</span>
            </div>

            <div :class="b('toolbar-item')">
              <div :class="b('toolbar-icon')">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                  fill="none"
                >
                  <path
                    d="M1 8.14H8.68M8.68 1V23.3C8.68 24.28 9.49 25.08
                      10.49 25.08H34M27.22 34V25.53M26.77 19.73V9.92C26.77
                      8.93 25.96 8.14 24.96 8.14H15.47"
                    stroke="#5F8AA4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span :class="b('toolbar-label')">Crop</span>
            </div>

            <div :class="b('toolbar-item')">
              <div :class="b('toolbar-icon')">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M29.37 20.69C27.46 26.68 21.99 31 15.55 31C7.51 31
                      1 24.28 1 16C1 7.72 7.51 1 15.55 1C20.93 1 25.63
                      4.02 28.15 8.5M23.73 10.38H31V2.88"
                    stroke="#5F8AA4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span :class="b('toolbar-label')">Rotate</span>
            </div>

            <div :class="b('toolbar-item')">
              <div :class="b('toolbar-icon')">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36"
                  height="34"
                  viewBox="0 0 36 34"
                  fill="none"
                >
                  <path
                    d="M6.72 33L22.93 17.79L30.56 25.39M6.72 33H25.79C28.95
                      33 31.51 30.45 31.51 27.3V17.79M6.72 33C3.56 33 1
                      30.45 1 27.3V8.28C1 5.13 3.56 2.58 6.72 2.58H19.12M29.61
                      11.76V6.38M29.61 6.38V1M29.61 6.38H24.21M29.61 6.38H35M12.44
                      11.13C12.44 12.71 11.16 13.98 9.58 13.98C8 13.98 6.72
                      12.71 6.72 11.13C6.72 9.56 8 8.28 9.58 8.28C11.16
                      8.28 12.44 9.56 12.44 11.13Z"
                    stroke="#5F8AA4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span :class="b('toolbar-label')">Change Photo</span>
            </div>

            <div :class="b('toolbar-item')">
              <div :class="b('toolbar-icon')">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="33"
                  height="35"
                  viewBox="0 0 33 35"
                  fill="none"
                >
                  <path
                    d="M22.31 11.68V6.82C22.31 3.61 19.71 1 16.5 1C13.29
                      1 10.69 3.61 10.69 6.82V11.68M4.76 34H28.24C30.32
                      34 32 32.35 32 30.31L29.59 10.71C29.59 8.67 27.91
                      7.01 25.84 7.01H6.7C4.62 7.01 2.94 8.67 2.94 10.71L1
                      30.31C1 32.35 2.68 34 4.76 34Z"
                    stroke="#5F8AA4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span :class="b('toolbar-label')">Change Product</span>
            </div>
          </div>

          </div>

        <!-- Right Side - Configurator -->
        <div :class="b('right-side')">
          <!-- Title -->
          <h2 :class="b('title')">LARGE PHOTO PRINTS</h2>

          <!-- Tabs and Price Row -->
          <div :class="b('tabs-price-row')">
            <div :class="b('tabs')">
              <button :class="b('tab', { active: true })">DESIGN</button>
              <button :class="b('tab')">EXPLORE</button>
            </div>
            <div :class="b('price-row')">
              <span :class="b('price-current')">$84.99</span>
              <span :class="b('price-old')">$119.99</span>
            </div>
          </div>

          <!-- Size Dropdown -->
          <div :class="b('dropdown')">
            <span :class="b('dropdown-label')">Choose Size</span>
            <div :class="b('dropdown-value-wrapper')">
              <span :class="b('dropdown-value')">8x10</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="15"
                viewBox="0 0 12 15"
                fill="none"
              >
                <path
                  d="M11.5 8.9L6 14.5L0.5 8.9M11.5 0.500001L6 6.1L0.5 0.5"
                  stroke="#5F8AA4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>

          <!-- Frame Section -->
          <div :class="b('frame-section')">
            <div :class="b('frame-header')">
              <span :class="b('frame-label')">2. Design Your Frame</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="15"
                viewBox="0 0 12 15"
                fill="none"
                style="transform: rotate(180deg)"
              >
                <path
                  d="M11.5 8.9L6 14.5L0.5 8.9M11.5 0.500001L6 6.1L0.5 0.5"
                  stroke="#5F8AA4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div :class="b('frame-options')">
              <button :class="b('frame-option', { active: true })">GLOSS</button>
              <button :class="b('frame-option')">MATTE</button>
              <button :class="b('frame-option')">SATIN</button>
            </div>
          </div>

          <!-- Add to Cart Row -->
          <div :class="b('cart-row')">
            <div :class="b('cart-price')">
              <span :class="b('cart-price-old')">$119.99</span>
              <span :class="b('cart-price-current')">$84.99</span>
            </div>
            <button
              :class="b('add-to-cart-btn')"
              :style="addToCartButtonColor
                ? { backgroundColor: addToCartButtonColor }
                : {}"
            >
              ADD TO CART
            </button>
          </div>

          <!-- Separator -->
          <div :class="b('separator')" />

          <!-- Custom Size Button -->
          <button :class="b('custom-size-btn')">
            Need a Specific size or execution?
          </button>
        </div>
      </div>
    </template>

    <!-- Mobile Layout -->
    <template v-else>
      <div :class="b('mobile-container')">
        <!-- Header -->
        <div :class="b('mobile-header')">
          <button :class="b('mobile-back-btn')">
            <svg
              width="24"
              height="21"
              viewBox="0 0 24 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 1L1 10.5L10 20M1 10.5H23"
                stroke="#293241"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <div :class="b('mobile-title-block')">
            <h2 :class="b('mobile-title')">LARGE PHOTO PRINTS</h2>
            <div :class="b('mobile-price')">
              <span :class="b('mobile-price-current')">$84.99</span>
              <span :class="b('mobile-price-old')">$119.99</span>
            </div>
          </div>
        </div>

        <!-- Preview Image -->
        <div :class="b('mobile-preview')" />

        <!-- Tabs -->
        <div :class="b('mobile-tabs')">
          <button :class="b('mobile-tab', { active: true })">DESIGN</button>
          <button :class="b('mobile-tab')">EXPLORE</button>
        </div>

        <!-- Size Dropdown -->
        <div :class="b('mobile-dropdown')">
          <span :class="b('mobile-dropdown-label')">SIZE</span>
          <div :class="b('mobile-dropdown-right')">
            <span :class="b('mobile-dropdown-value')">8x10</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="15"
              viewBox="0 0 12 15"
              fill="none"
            >
              <path
                d="M11.5 8.9L6 14.5L0.5 8.9M11.5 0.500001L6 6.1L0.5 0.5"
                stroke="#5F8AA4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>

        <!-- Frame Section -->
        <div :class="b('mobile-frame-section')">
          <div :class="b('mobile-frame-header')">
            <span :class="b('mobile-frame-label')">FRAME</span>
            <div :class="b('mobile-frame-header-right')">
              <span :class="b('mobile-frame-value')">SATIN</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="15"
                viewBox="0 0 12 15"
                fill="none"
                style="transform: rotate(180deg)"
              >
                <path
                  d="M11.5 8.9L6 14.5L0.5 8.9M11.5 0.500001L6 6.1L0.5 0.5"
                  stroke="#5F8AA4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div :class="b('mobile-frame-options')">
            <button :class="b('mobile-frame-option')">MATTE</button>
            <button :class="b('mobile-frame-option', { active: true })">SATIN</button>
            <button :class="b('mobile-frame-option')">GLOSS</button>
          </div>
        </div>

        <!-- Cart Row -->
        <div :class="b('mobile-cart-row')">
          <div :class="b('mobile-cart-price')">
            <span :class="b('mobile-cart-price-old')">$119.99</span>
            <span :class="b('mobile-cart-price-current')">$84.99</span>
          </div>
          <button
            :class="b('mobile-add-to-cart-btn')"
            :style="addToCartButtonColor
              ? { backgroundColor: addToCartButtonColor }
              : {}"
          >
            ADD TO CART
          </button>
        </div>

        <!-- Custom Size Button -->
        <button :class="b('mobile-custom-size-btn')">
          CAN'T FIND YOUR SIZE?
        </button>

        <!-- Toolbar -->
        <div :class="b('mobile-toolbar')">
          <div :class="b('mobile-toolbar-item')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="27"
              height="35"
              viewBox="0 0 27 35"
              fill="none"
            >
              <path
                d="M25.75 31.46V3.54C25.75 2.14 24.64 1 23.28 1H3.48C2.1 1
                  1 2.14 1 3.54V31.46C1 32.86 2.1 34 3.48 34H23.28C24.64
                  34 25.75 32.86 25.75 31.46Z"
                stroke="#5F8AA4"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.2 13.66C18.88 13.66 20.24 12.27 20.24 10.54C20.24
                  8.82 18.88 7.43 17.2 7.43C15.53 7.43 14.16 8.82 14.16
                  10.54C14.16 12.27 15.53 13.66 17.2 13.66Z"
                stroke="#5F8AA4"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 19.55C1.86 19.4 2.73 19.33 3.61 19.33C6.64 19.26
                  9.59 20.19 11.95 21.93C15.76 24.75 17.2 29.64 17.2 34"
                stroke="#5F8AA4"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M25.75 23.52C24.07 23 22.31 22.74 20.54 22.74C18.3
                  22.73 16.09 23.15 14.03 23.95"
                stroke="#5F8AA4"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>Portrait</span>
          </div>
          <div :class="b('mobile-toolbar-item')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 35 35"
              fill="none"
            >
              <path
                d="M1 8.14H8.68M8.68 1V23.3C8.68 24.28 9.49 25.08
                  10.49 25.08H34M27.22 34V25.53M26.77 19.73V9.92C26.77
                  8.93 25.96 8.14 24.96 8.14H15.47"
                stroke="#5F8AA4"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>Crop</span>
          </div>
          <div :class="b('mobile-toolbar-item')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="34"
              viewBox="0 0 36 34"
              fill="none"
            >
              <path
                d="M6.72 33L22.93 17.79L30.56 25.39M6.72 33H25.79C28.95
                  33 31.51 30.45 31.51 27.3V17.79M6.72 33C3.56 33 1
                  30.45 1 27.3V8.28C1 5.13 3.56 2.58 6.72 2.58H19.12M29.61
                  11.76V6.38M29.61 6.38V1M29.61 6.38H24.21M29.61 6.38H35M12.44
                  11.13C12.44 12.71 11.16 13.98 9.58 13.98C8 13.98 6.72
                  12.71 6.72 11.13C6.72 9.56 8 8.28 9.58 8.28C11.16
                  8.28 12.44 9.56 12.44 11.13Z"
                stroke="#5F8AA4"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>Edit Photo</span>
          </div>
          <div :class="b('mobile-toolbar-item')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="33"
              height="35"
              viewBox="0 0 33 35"
              fill="none"
            >
              <path
                d="M22.31 11.68V6.82C22.31 3.61 19.71 1 16.5 1C13.29
                  1 10.69 3.61 10.69 6.82V11.68M4.76 34H28.24C30.32
                  34 32 32.35 32 30.31L29.59 10.71C29.59 8.67 27.91
                  7.01 25.84 7.01H6.7C4.62 7.01 2.94 8.67 2.94 10.71L1
                  30.31C1 32.35 2.68 34 4.76 34Z"
                stroke="#5F8AA4"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>Edit Product</span>
          </div>
        </div>

        </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables';
@import '@/styles/media';

.create-wizard-module {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  font-family: Montserrat, sans-serif;

  // ==========================================
  // Desktop Styles
  // ==========================================

  &__container {
    display: flex;
    gap: 28px;
    width: 100%;
    max-width: 1730px;
    padding: 40px 0;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(28);
      max-width: vw-full(1730);
      padding: vw-full(40) 0;
    }
  }

  &__left-side {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  &__main-preview {
    position: relative;
    width: 900px;
    height: 675px;
    border-radius: 20px 20px 0 0;
    overflow: hidden;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(900);
      height: vw-full(675);
      border-radius: vw-full(20) vw-full(20) 0 0;
    }
  }

  &__preview-placeholder {
    width: 100%;
    height: 100%;
    background: #D9D9D9;
  }

  &__expand-icon {
    position: absolute;
    bottom: 16px;
    right: 16px;
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(2px);
    border-radius: 20px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: center;

    @include mediaMinMax(1025, $normal) {
      bottom: vw-full(16);
      right: vw-full(16);
      width: vw-full(48);
      height: vw-full(48);
      border-radius: vw-full(20) 0 0 0;
    }
  }

  &__toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 900px;
    height: 84px;
    padding: 0 40px;
    background: #FFF;
    border-radius: 0 0 20px 20px;
    box-shadow: 4px 4px 8px 0 rgba(95, 138, 164, 0.2);

    @include mediaMinMax(1025, $normal) {
      width: vw-full(900);
      height: vw-full(84);
      padding: 0 vw-full(40);
      border-radius: 0 0 vw-full(20) vw-full(20);
    }
  }

  &__toolbar-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(8);
    }
  }

  &__toolbar-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35px;

    @include mediaMinMax(1025, $normal) {
      height: vw-full(35);

      svg {
        width: auto;
        height: 100%;
      }
    }
  }

  &__toolbar-label {
    font-size: 16px;
    font-weight: 400;
    color: #7F7F7F;
    text-align: center;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(16);
    }
  }

  // Right Side
  &__right-side {
    display: flex;
    flex-direction: column;
    width: 612px;
    padding-top: 20px;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(612);
      padding-top: vw-full(20);
    }
  }

  &__title {
    font-size: 32px;
    font-weight: 400;
    color: #293241;
    text-transform: uppercase;
    margin: 0 0 16px 0;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(32);
      margin: 0 0 vw-full(16) 0;
    }
  }

  &__tabs-price-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    padding-bottom: 8px;
    border-bottom: 2px solid #D7E8F0;

    @include mediaMinMax(1025, $normal) {
      margin-bottom: vw-full(24);
      padding-bottom: vw-full(8);
    }
  }

  &__tabs {
    display: flex;
    gap: 0;
  }

  &__tab {
    padding: 8px 24px;
    font-size: 20px;
    font-weight: 400;
    color: #7F7F7F;
    text-transform: uppercase;
    background: transparent;
    border: none;
    cursor: pointer;
    position: relative;

    @include mediaMinMax(1025, $normal) {
      padding: vw-full(8) vw-full(24);
      font-size: vw-full(20);
    }

    &_active {
      font-weight: 500;
      color: #5F8AA4;

      &::after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 0;
        width: 100%;
        height: 2px;
        background: #5F8AA4;

        @include mediaMinMax(1025, $normal) {
          bottom: vw-full(-10);
        }
      }
    }
  }

  &__price-row {
    display: flex;
    align-items: baseline;
    gap: 8px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(8);
    }
  }

  &__price-current {
    font-size: 24px;
    font-weight: 500;
    color: #ECC486;
    text-transform: uppercase;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(24);
    }
  }

  &__price-old {
    font-size: 16px;
    font-weight: 400;
    color: #7F7F7F;
    text-decoration: line-through;
    text-transform: uppercase;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(16);
    }
  }

  &__dropdown {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 60px;
    padding: 0 20px;
    background: #FFF;
    border: 1px solid #D7E8F0;
    border-radius: 20px;
    margin-bottom: 24px;

    @include mediaMinMax(1025, $normal) {
      height: vw-full(60);
      padding: 0 vw-full(20);
      border-radius: vw-full(20);
      margin-bottom: vw-full(24);
    }
  }

  &__dropdown-label {
    font-size: 20px;
    font-weight: 400;
    color: #293241;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(20);
    }
  }

  &__dropdown-value-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(12);
    }
  }

  &__dropdown-value {
    font-size: 20px;
    font-weight: 400;
    color: #7F7F7F;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(20);
    }
  }

  &__frame-section {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 20px;
    background: #FFF;
    border: 1px solid #D7E8F0;
    border-radius: 20px;
    margin-bottom: 24px;

    @include mediaMinMax(1025, $normal) {
      padding: vw-full(20);
      border-radius: vw-full(20);
      margin-bottom: vw-full(24);
    }
  }

  &__frame-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    @include mediaMinMax(1025, $normal) {
      margin-bottom: vw-full(16);
    }
  }

  &__frame-label {
    font-size: 20px;
    font-weight: 400;
    color: #293241;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(20);
    }
  }

  &__frame-options {
    display: flex;
    gap: 24px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(24);
    }
  }

  &__frame-option {
    width: 180px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 400;
    color: #7F7F7F;
    text-transform: uppercase;
    background: #FFF;
    border: 2px solid #D9D9D9;
    border-radius: 20px;
    cursor: pointer;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(180);
      height: vw-full(52);
      font-size: vw-full(20);
      border-radius: vw-full(20);
    }

    &_active {
      font-weight: 500;
      color: #5F8AA4;
      border-color: #ECC486;
      box-shadow: 3px 3px 6px 0 rgba(236, 196, 134, 0.65);
    }
  }

  &__cart-row {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 24px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(16);
      margin-bottom: vw-full(24);
    }
  }

  &__cart-price {
    display: flex;
    align-items: baseline;
    gap: 8px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(8);
    }
  }

  &__cart-price-old {
    font-size: 16px;
    font-weight: 400;
    color: #7F7F7F;
    text-decoration: line-through;
    text-transform: uppercase;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(16);
    }
  }

  &__cart-price-current {
    font-size: 24px;
    font-weight: 500;
    color: #ECC486;
    text-transform: uppercase;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(24);
    }
  }

  &__add-to-cart-btn {
    flex: 1;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 500;
    color: #000;
    text-transform: uppercase;
    background: #ECC486;
    border: none;
    border-radius: 30px;
    cursor: pointer;

    @include mediaMinMax(1025, $normal) {
      height: vw-full(60);
      font-size: vw-full(24);
      border-radius: vw-full(30);
    }
  }

  &__separator {
    width: 100%;
    height: 1px;
    background: #DDD;
    margin-bottom: 24px;

    @include mediaMinMax(1025, $normal) {
      margin-bottom: vw-full(24);
    }
  }

  &__custom-size-btn {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 400;
    color: #000;
    text-transform: uppercase;
    background: #FFF;
    border: 1px solid #DDD;
    border-radius: 30px;
    cursor: pointer;

    @include mediaMinMax(1025, $normal) {
      height: vw-full(60);
      font-size: vw-full(24);
      border-radius: vw-full(30);
    }
  }

  // ==========================================
  // Mobile Styles
  // ==========================================

  &_mobile {
    background: #FFF;
  }

  &__mobile-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 412px;
  }

  &__mobile-header {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 20px;
  }

  &__mobile-back-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
  }

  &__mobile-title-block {
    display: flex;
    flex-direction: column;
    flex: 1;
    text-align: right;
  }

  &__mobile-title {
    font-size: 20px;
    font-weight: 400;
    color: #293241;
    text-transform: uppercase;
    margin: 0;
  }

  &__mobile-price {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    gap: 8px;
  }

  &__mobile-price-current {
    font-size: 20px;
    font-weight: 400;
    color: #ECC486;
    text-transform: uppercase;
  }

  &__mobile-price-old {
    font-size: 12px;
    font-weight: 400;
    color: #7F7F7F;
    text-decoration: line-through;
    text-transform: uppercase;
  }

  &__mobile-preview {
    width: 100%;
    height: 330px;
    background: #D9D9D9;
  }

  &__mobile-tabs {
    display: flex;
    width: 100%;
    height: 36px;
  }

  &__mobile-tab {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 400;
    color: #7F7F7F;
    text-transform: uppercase;
    background: #FFF;
    border: none;
    cursor: pointer;

    &_active {
      font-weight: 500;
      color: #FFF;
      background: #5F8AA4;
      border-radius: 0 0 20px 0;
    }
  }

  &__mobile-dropdown {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 16px 28px;
    padding: 12px 16px;
    background: #FFF;
    border: 1px solid #D7E8F0;
    border-radius: 20px;
  }

  &__mobile-dropdown-label {
    font-size: 16px;
    font-weight: 400;
    color: #293241;
    text-transform: uppercase;
    letter-spacing: -0.32px;
  }

  &__mobile-dropdown-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__mobile-dropdown-value {
    font-size: 16px;
    font-weight: 400;
    color: #7F7F7F;
    letter-spacing: -0.32px;
  }

  &__mobile-frame-section {
    display: flex;
    flex-direction: column;
    margin: 0 28px 16px;
    padding: 16px;
    background: #FFF;
    border: 1px solid #D7E8F0;
    border-radius: 20px;
    box-shadow: 3px 3px 6px 0 rgba(95, 138, 164, 0.2);
  }

  &__mobile-frame-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 12px;
    border-bottom: 1px solid #D7E8F0;
    margin-bottom: 12px;
  }

  &__mobile-frame-label {
    font-size: 16px;
    font-weight: 400;
    color: #293241;
    text-transform: uppercase;
    letter-spacing: -0.32px;
  }

  &__mobile-frame-header-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__mobile-frame-value {
    font-size: 16px;
    font-weight: 400;
    color: #7F7F7F;
    letter-spacing: -0.32px;
  }

  &__mobile-frame-options {
    display: flex;
    gap: 12px;
  }

  &__mobile-frame-option {
    flex: 1;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
    color: #7F7F7F;
    text-transform: uppercase;
    background: #FFF;
    border: 1px solid #D9D9D9;
    border-radius: 12px;
    cursor: pointer;

    &_active {
      font-weight: 500;
      color: #5F8AA4;
      border: 2px solid #ECC486;
      box-shadow: 3px 3px 6px 0 rgba(236, 196, 134, 0.65);
    }
  }

  &__mobile-cart-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 20px;
    margin-bottom: 16px;
  }

  &__mobile-cart-price {
    display: flex;
    align-items: baseline;
    gap: 4px;
  }

  &__mobile-cart-price-old {
    font-size: 12px;
    font-weight: 400;
    color: #7F7F7F;
    text-decoration: line-through;
    text-transform: uppercase;
  }

  &__mobile-cart-price-current {
    font-size: 16px;
    font-weight: 400;
    color: #ECC486;
    text-transform: uppercase;
  }

  &__mobile-add-to-cart-btn {
    flex: 1;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 400;
    color: #293241;
    text-transform: uppercase;
    background: #ECC486;
    border: none;
    border-radius: 25px;
    cursor: pointer;
  }

  &__mobile-custom-size-btn {
    margin: 0 28px 16px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 400;
    color: #293241;
    text-transform: uppercase;
    background: #FFF;
    border: 1px solid #DDD;
    border-radius: 20px;
    cursor: pointer;
    letter-spacing: -0.32px;
  }

  &__mobile-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 76px;
    background: #FFF;
    box-shadow: 0 0 10px 0 rgba(95, 138, 164, 0.3);
  }

  &__mobile-toolbar-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;

    svg {
      height: 26px;
      width: auto;
    }

    span {
      font-size: 12px;
      font-weight: 400;
      color: #7F7F7F;
    }
  }
}
</style>
